import axios from 'axios';
import { defaultAxiosConfig, getAcessToken } from './commom';

export const enum SearchTruckerMessageError {
  undefined = 'Não foi possível conectar ao servidor.',
  duplicated = 'Resposta invalida por conta de duplicidade',
  notActive = 'Motorista inativo na plataforma.',
  notFound = 'cpf or phone not found',
}

const statusMessages: Record<number, string> = {
  401: process.env.FRETEBRAS_LOGOUT_URL,
  409: SearchTruckerMessageError.duplicated,
  422: SearchTruckerMessageError.notFound,
  423: SearchTruckerMessageError.notActive,
};

const handleError = (err: unknown) => {
  const status = err?.response?.status;

  // eslint-disable-next-line no-prototype-builtins
  if (!statusMessages.hasOwnProperty(status)) {
    return Promise.reject(new Error(SearchTruckerMessageError.undefined));
  }

  if (status === 401) {
    window.location.assign(statusMessages[status]);
    return Promise.resolve();
  }

  return Promise.reject(new Error(statusMessages[status]));
};

const truckerProfileApiService = axios.create({
  baseURL: process.env.BFF_TRUCKER_PROFILE_URL,
  ...defaultAxiosConfig,
});

truckerProfileApiService.interceptors.request.use(
  (request) => getAcessToken(request),
  (err) => Promise.reject(err)
);

truckerProfileApiService.interceptors.response.use(
  (response) => response.data,
  (err) => handleError(err)
);

export { truckerProfileApiService };
